






















































import { Vue, Component, Prop } from 'vue-property-decorator';

import RespectCard from '~/components/cards/RespectCard.vue';
import ExperiencesPicker from '~/components/lists/ExperiencesPicker.vue';
import LabelsInfos from "~/components/partials/LabelsInfos.vue";

@Component({
  components: { LabelsInfos, RespectCard, ExperiencesPicker },
})
export default class DestinationStickyMenu extends Vue {
  @Prop(Object) destination: Types.DestinationItem;
  @Prop(Array) links: [];
  @Prop(Array) destinationSports: [];

  /* This method updates the style of the scrolled active element */
  onItemChanged (event: Event, currentItem: HTMLElement, lastActiveItem: HTMLElement) {
    if (process.client) {
      if (currentItem && lastActiveItem) {
        document.querySelectorAll('.SubMenuItem')[0]?.classList.remove('active');
        currentItem.classList.add('active');
        lastActiveItem.classList.remove('active');
      } else {
        document.querySelectorAll('.SubMenuItem')[0]?.classList.add('active');
      }
    }
  }
}
